import { FC } from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';
import { TProductDetails } from '~/shared/components/ProductCard/ProductCard.definition';
import { Container } from '~/shared/components/Container';
import Typography from '~/shared/components/Typography/Typography';
import styles from './SearchPageHero.module.scss';

export interface SearchPageHeroProps {
    headline: string;
    belowText?: string;
}

const SearchPageHero: FC<SearchPageHeroProps> = ({ headline, belowText }) => {
    const { hits, results } = useHits<TProductDetails>();
    const { status } = useInstantSearch();

    const shouldShowBelowText =
        status !== 'loading' && !!results?.query && belowText && !hits.length;

    return (
        <div className={styles.searchPageHero}>
            <Container hasGutter>
                <Typography className={styles.title} as="h1" variant="title-M">
                    {headline}
                </Typography>

                {shouldShowBelowText && (
                    <Typography className={styles.belowText} as="p" variant="paragraph-M">
                        {belowText}
                    </Typography>
                )}
            </Container>
        </div>
    );
};

export default SearchPageHero;
